import slidersettings from '../config/slider.js';
import Swiper from 'swiper' ; // idangero.us/swiper

const $ = jQuery;

export default class SliderAbstract {
    constructor(selector) {
        if ($(selector).length == 0) {
            return;
        }

        this.selector = selector;
        this.originalSettings = Object.assign({}, slidersettings.config);
        //use substr to remove . or # from selector
        this.originalSettings.containerModifierClass = this.selector.substr(1) + '--';

        this._init();
    }

    _isMobileView() {
        return $('.page__header').find('.page__actions').is(':visible');
    }

    _init() {
        //IMPLEMENT IN SPECIFIC CLASS
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/SliderAbstract.js